import React from "react";
import {
  FaBell,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMoon,
  FaPhone,
  FaRegEnvelope,
  FaSignInAlt,
  FaSignOutAlt,
  FaSun,
} from "react-icons/fa";
import { MdOutlineMessage } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { useNotification } from "../../../../contexts/NotificationContext";
import { useContactForm } from "../../../../contexts/ContactFormContext";
import { useThemeMode } from "../hooks/useThemeMode";
import { useUnreadMessages } from "../hooks/useUnreadMessages";
import { safeOpenExternal } from "../utils/navigationUtils";

import NavIconButton from "../ui/NavIconButton";
import UserAvatarButton from "../ui/UserAvatarButton";

const TopBar = ({ user, settings, onLogout }) => {
  const navigate = useNavigate();
  const { unreadCount } = useNotification();
  const { unreadCountContactForm } = useContactForm();
  const { isDark, toggleTheme } = useThemeMode();
  const unreadMessages = useUnreadMessages(user);

  const roleId = Number(user?.role_id || 0);
  const isAdmin = roleId === 1;

  const handleLogout = () => {
    onLogout?.();
    navigate("/");
  };

  const goToProfile = () => {
    navigate("/profile");
  };

  return (
    <div className="w-full overflow-x-clip border-b border-white/10 bg-slate-950 text-white">
      <div className="mx-auto flex h-11 w-full max-w-[1380px] min-w-0 items-center justify-between px-2 sm:h-12 sm:px-4 lg:px-6">
        <div className="hidden min-w-0 items-center gap-2 text-xs text-slate-300 md:flex">
          <span className="truncate font-bold uppercase tracking-[0.24em] text-orange-300">
            MonAppliTournoi
          </span>
        </div>

        <div className="ml-auto flex min-w-0 max-w-full items-center justify-end gap-1 sm:gap-2">
          {settings?.mail_club && (
            <NavIconButton
              icon={FaEnvelope}
              label="Envoyer un e-mail"
              href={`mailto:${settings.mail_club}`}
              className="hidden sm:inline-flex"
            />
          )}

          {settings?.tel_club && (
            <NavIconButton
              icon={FaPhone}
              label="Appeler"
              href={`tel:${settings.tel_club}`}
              className="hidden sm:inline-flex"
            />
          )}

          {settings?.facebook_club && (
            <NavIconButton
              icon={FaFacebookF}
              label="Facebook"
              onClick={() => safeOpenExternal(settings.facebook_club)}
              className="hidden md:inline-flex"
            />
          )}

          {settings?.instagram_club && (
            <NavIconButton
              icon={FaInstagram}
              label="Instagram"
              onClick={() => safeOpenExternal(settings.instagram_club)}
              className="hidden md:inline-flex"
            />
          )}

          <div className="mx-1 hidden h-6 w-px bg-white/10 sm:block" />

          {user ? (
            <>
              <UserAvatarButton user={user} onClick={goToProfile} />

              <NavIconButton
                icon={FaSignOutAlt}
                label="Déconnexion"
                onClick={handleLogout}
              />

              {isAdmin && (
                <>
                  <div className="mx-1 hidden h-6 w-px bg-white/10 sm:block" />

                  <NavIconButton
                    icon={FaBell}
                    label="Notifications"
                    badge={unreadCount}
                    onClick={() => navigate("/notifications")}
                  />

                  <NavIconButton
                    icon={FaRegEnvelope}
                    label="Messages"
                    badge={unreadMessages}
                    onClick={() => navigate("/messages")}
                  />

                  <NavIconButton
                    icon={MdOutlineMessage}
                    label="Messages du formulaire"
                    badge={unreadCountContactForm}
                    onClick={() => navigate("/formulaire-contact")}
                  />
                </>
              )}
            </>
          ) : (
            <NavIconButton
              icon={FaSignInAlt}
              label="Connexion"
              onClick={() => navigate("/login")}
            />
          )}

          <button
            type="button"
            onClick={toggleTheme}
            className="
              inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl
              border border-white/10 bg-white/10 text-white transition
              hover:-translate-y-0.5 hover:bg-white/20
              focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300
              sm:h-10 sm:w-10 sm:rounded-2xl
            "
            title={isDark ? "Mode clair" : "Mode sombre"}
            aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
          >
            {isDark ? (
              <FaSun className="h-4 w-4" />
            ) : (
              <FaMoon className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopBar;